
        import * as module0 from './controllers/crime_controller.js'
        const modules = {
            "./controllers/crime_controller.js": module0,
        };
        export default modules;
      